import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Award, AwardRequest } from './AwardTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Award>>('/author/awards/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Award>(`/author/awards/${id}`).then(getData);
}

export function edit(id: Id, request: AwardRequest) {
  return axios.put<Award>(`/author/awards/${id}`, request).then(getData);
}

export function create(request: AwardRequest) {
  return axios.post<Award>(`/author/awards`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/awards/${id}`).then(getData);
}
